import { Component } from "react";
import { render } from 'react-dom';
import styles from './index.css';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import RaisedButton from 'material-ui/RaisedButton';

export default class App extends Component {
    constructor(props) {
        super(props);
        this.english = 'https://www.cv-mallen.se/online-cv/magahl/magnus-ahlberg-resume-english';
        this.swedish = 'https://www.cv-mallen.se/online-cv/magahl/magnus-ahlberg-resume';
        this.state = {
            url: this.swedish
        };
    }

    render() {
        const style = {
            margin: 12,
            backgroundColor: '#23323f'
        };
        return (
            <MuiThemeProvider>
                <div>
                    <div className={styles.languageSwitcher}>
                        <RaisedButton style={style} primary={this.state.url == this.swedish} label="Swedish" onClick={x => this.setUrl(this.swedish)} />
                        <RaisedButton style={style} primary={this.state.url == this.english} label="English" onClick={x => this.setUrl(this.english)} />
                    </div>
                    <iframe className={styles.frame} src={this.state.url} width="100%" height="100%" />
                </div >
            </MuiThemeProvider>);
    }

    setUrl(url) {
        this.setState({ url: url })
    }
}

render(<App />, document.getElementById('app'));


// WEBPACK FOOTER //
// ./app.js